import { runningInBrowser } from "~/const/browser";
import { EXTERNAL_PATHS } from "~/const/paths";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { uriConverter } from "~/util/uri-converter";

type GoToWelcomePageArgs = Partial<{
  /** ページの履歴を書き変えたいかどうかを判定 */
  isReplace: boolean;
  /**
   * seasonId
   * - mini末端からwelcome pageに遷移する時付与する
   **/
  seasonId?: string;
  /**
   * contentId
   * - 対象作品がepisode単位且つmini末端からwelcome pageに遷移する時付与する
   **/
  contentId?: string;
}>;

/**
 * 入会訴求導線に遷移する処理
 *
 * @param args {@link GoToWelcomePageArgs}
 */

export const goToWelcomePage = (args?: GoToWelcomePageArgs) => {
  const { isReplace = false, seasonId, contentId } = args || {};

  if (!runningInBrowser) return;

  const url = generateUrl({ href: location.href, seasonId, contentId });

  const backUrl = uriConverter.encode(url);
  const welcomePageUrl = `${EXTERNAL_PATHS.WELCOME}${backUrl}`;

  if (isReplace) {
    location.replace(welcomePageUrl);
    return;
  }

  sendTrackingClickCommon({ clickEventName: "dmmtv_button_to_welcome", viaTargetId: seasonId && seasonId });

  location.href = welcomePageUrl;
};

const reg = /\?/;

type GenerateUrlArgs = { href: string; seasonId?: string; contentId?: string };

const generateUrl = ({ href, seasonId, contentId }: GenerateUrlArgs) => {
  if (seasonId === undefined) return href;
  const hrefWithQueryPrefix = `${href}${reg.test(href) ? "&" : "?"}`;

  if (contentId !== undefined) return `${hrefWithQueryPrefix}season=${seasonId}&content=${contentId}`;
  return `${hrefWithQueryPrefix}season=${seasonId}`;
};
